<template>
    <div 
      class="shortcut-item"
      :class="{'has-filter': hasFilter}" 
      @click="$emit('clickFilter')"
      >
      <slot>筛选</slot>      
      <van-icon name="filter-fill" class-prefix="vxs-icon" size="14" />
    </div>
</template>

<script>
export default {
  kind: 'yq-筛选',
  props: {
    hasFilter: {
      type: Boolean,
      default: false,
    }
  },
  data() {
    return {};
  },
  computed: {},
  created() {},
};
</script>


